import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { createAwsClient } from './backends/awsClient'

// Build-time backend switch. The default ('supabase') is the production
// Netlify/Supabase path and is completely unaffected by the AWS deployment.
// Set VITE_BACKEND=aws to build the AWS variant (Cognito auth + self-hosted
// PostgREST), selected entirely here — no other app file changes. See
// aws/README.md.
//
// VITE_BACKEND is statically inlined by Vite, so when it is not 'aws' the
// createAwsClient() branch is dead code and Rollup tree-shakes it (and the
// Cognito SDK) out of the Supabase bundle. The backend modules are kept free
// of top-level side effects to allow this.

function createSupabaseBackend(): SupabaseClient {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
      'Supabase environment variables are not set. Auth and database features will not work.',
    )
  }

  return createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder',
  )
}

export const supabase: SupabaseClient =
  import.meta.env.VITE_BACKEND === 'aws' ? createAwsClient() : createSupabaseBackend()
